import React from 'react';

export default function Image(props){
   return <div id={props.id}><img className ={props.className} src={props.src} alt={props.alt} /></div>;
}